import { render, staticRenderFns } from "./LabelSettings.vue?vue&type=template&id=3568021c&scoped=true&"
import script from "./LabelSettings.vue?vue&type=script&lang=js&"
export * from "./LabelSettings.vue?vue&type=script&lang=js&"
import style0 from "./LabelSettings.vue?vue&type=style&index=0&id=3568021c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568021c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3568021c')) {
      api.createRecord('3568021c', component.options)
    } else {
      api.reload('3568021c', component.options)
    }
    module.hot.accept("./LabelSettings.vue?vue&type=template&id=3568021c&scoped=true&", function () {
      api.rerender('3568021c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Label/LabelSettings.vue"
export default component.exports